import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExpandService {
  private isExpandedAll: boolean = false; // Initial state

  constructor() {}

  // Get the current state
  getExpandState(): boolean {
    return this.isExpandedAll;
  }

  // Toggle the state
  toggleExpandState() {
    this.isExpandedAll = !this.isExpandedAll;
  }

  // Explicitly set the state
  setExpandState(value: boolean) {
    this.isExpandedAll = value;
  }
}
